import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router'
import { getJobsheetView, getPendingReasonFilterLoading } from 'src/store/actions';
import { RootReducerState } from 'src/store/reducers';
import FeatherIcon from "feather-icons-react";
import { ref, onValue, push, set } from "firebase/database";
// import { db } from 'src/Notifications/firebaseNew';
import { getLabel } from '../JobSheets';
import { Chips } from 'primereact/chips';
import { Checkbox } from 'primereact/checkbox';
import { hasAdminOrEmployeeRoleHandler } from 'src/helpers/common_helpers';
import { useToast } from 'src/components/Common/ReactToaster';

const ChatPage = ({id}:any) => {
  
  const dispatch = useDispatch();
const { pendingReasonFilter } = useSelector((state:RootReducerState)=>state.jobsheetReducer);
  const { profile} = useSelector(
    (state: RootReducerState) => state.profilesReducer
  );
const [sendEmail, setSendEmail] = useState(false);
const [emails, setEmails] = useState<string[]>([]);
const { showToast } = useToast();

    const pendingReasonDropdown = useMemo(()=>{
      return pendingReasonFilter?.filter((data:any)=>data.isDeleted != true).map((data:any)=>({
        label:getLabel(data.name),
        value:data.name,
      })).splice(0,7) || [];
    },[pendingReasonFilter])
  
//   useEffect(()=>{
//     if(id){
//        listenForMessages(id);
//        dispatch(getPendingReasonFilterLoading());
//     }
//      const chatRef = ref(db, `jobChats/${id}/messages`);
//     const unsubscribe = onValue(chatRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const msgs = Object.values(data);
//         msgs.sort((a: any, b: any) => a.timestamp - b.timestamp);
//         setMessages(msgs);
//       } else {
//         setMessages([]);
//       }
//     });
//     return  () => unsubscribe();
//   },[id])

// const listenForMessages = (jobId: string) => {
//     const chatRef = ref(db, `jobChats/${jobId}/messages`);
//     onValue(chatRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const msgs = Object.values(data);
//         setMessages(msgs.sort((a: any, b: any) => a.timestamp - b.timestamp));
//       } else {
//         setMessages([]);
//       }
//     });
//   };

    const [messages, setMessages] = useState<any>([]);
  const [newMessage, setNewMessage] = useState("");
  const messagesEndRef:any = useRef(null);
  // Scroll to bottom when new messages appear
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");

  const handleSend = (e: React.FormEvent) => {
    e.preventDefault();
    debugger
    if (!newMessage.trim() || !id) return;

    // const msgRef = ref(db, `jobChats/${id}/messages`);
    // const newMsgRef = push(msgRef);

    const messageData = {
      // id: newMsgRef.key,
      sender: Array.isArray(authUser.role) ? authUser.role[0] : authUser.role,
      name: profile?.name || "Admin",
      text: newMessage,
      timestamp: Date.now(),
      userId: authUser.uid,
    };

    // set(newMsgRef, messageData);
    setNewMessage("");
  };
  const handleSelect = (value:string) => {
    if (!value.trim() || !id) return;

    // const msgRef = ref(db, `jobChats/${id}/messages`);
    // const newMsgRef = push(msgRef);

    const messageData = {
      // id: newMsgRef.key,
      sender: Array.isArray(authUser.role) ? authUser.role[0] : authUser.role,
      name: profile?.name || "Admin",
      text: value,
      timestamp: Date.now(),
      userId: authUser.uid,
    };

    // set(newMsgRef, messageData);
    setNewMessage("");
  };


  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const groupMessagesByDate = (messages: any[]) => {
  return messages.reduce((groups: any, message: any) => {
    const date = new Date(message.timestamp).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    if (!groups[date]) groups[date] = [];
    groups[date].push(message);
    return groups;
  }, {});
};

const groupedMessages = useMemo(() => groupMessagesByDate(messages), [messages]);
console.log("pendingReasonDropdown",pendingReasonDropdown)
const rightUser = Array.isArray(authUser.role) ? authUser.role[0] : [authUser.role]

 const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // ✅ Handle add/remove in Chips manually
  const handleEmailChange = (e: any) => {
    const latestValue = e.value?.[e.value.length - 1];
    if (latestValue && !emailRegex.test(latestValue)) {
      // Invalid email → remove last one
      e.value.pop();
      showToast(`${latestValue} is not a valid email address`,{type:"error"});
    }
    setEmails(e.value);
  };
  
  const handleEmailButton  = () =>{
    setSendEmail(!sendEmail);
    if(!sendEmail){
      setEmails([]);
    }
  }
  return (
    <div>
      <div className="chat-page">
      {/* <div className="chat-header">
        <div className="chat-logo">
          <img src={`https://ui-avatars.com/api/?name=${jobsheetView?.jobPrefix}&background=ff5722&color=fff`} alt="" />
          <span className='jobno'>{jobsheetView?.number ? <>{jobsheetView?.number}</> : <>WIP</>}</span>
        </div>
        <div className="job-details">
          <span className='color-green' style={{color:"green"}}>{`${jobsheetView?.isExchange ? "Exchange Job" : "Non Exchange Job"}`}</span>
        </div>
      </div> */}
      {/* pending comments */}
      {hasAdminOrEmployeeRoleHandler() &&
        <div className="pending-commands">
          <b>You can select here for Chat!!!</b>
          <div className="pending-reason">
            {pendingReasonDropdown?.map((reason:any)=>{
              return(
                <span key={reason.value} className="pending-chip" onClick={()=>handleSelect(reason.label)}>{reason.label}</span>
              )
            })}
            </div>
        </div>
}
    {/* body start */}
    <div className={`chat-body ${hasAdminOrEmployeeRoleHandler() ? "admin" : "user"}`}>
  {Object.entries(groupedMessages || {}).map(([date, msgs]: any) => (
    <div key={date}>
      {/* Date Header */}
      <div className="chat-date-divider">
        <span className='chat-date'>{date}</span>
      </div>

      {/* Messages for this date */}
      {msgs?.map((msg:any) => {
        const formattedTime = new Date(msg.timestamp).toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
        });
        return (
          <div key={msg.id}>
            <span
              className={`chat-info ${
                rightUser.includes(msg.sender) ? "right" : "left"
              }`}
            >
              {msg.name} <span className="chat-time">{formattedTime}</span>
            </span>
            <div
              className={`chat-message ${
                rightUser.includes(msg.sender) ? "right" : "left"
              }`}
            >
              <div className="bubble">{msg.text}</div>
            </div>
          </div>
        );
      })}
    </div>
  ))}
  <div ref={messagesEndRef} />
</div>
    {/* body end */}

      {/* Input Box */}
      <form className="chat-input" onSubmit={handleSend}>
        <textarea
          placeholder="Type a message..."
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
        />
        <button type="submit"><FeatherIcon icon={"send"}/></button>
      </form>
      {hasAdminOrEmployeeRoleHandler() ?
        <div className="chat-options p-mt-2">
  {/* <div className="p-field-checkbox">
    <Checkbox
      inputId="sendEmail"
      checked={sendEmail}
      onChange={e => setSendEmail(e.checked || false)}
    />
    <label htmlFor="sendEmail" className="p-ml-2" style={{margin:"0px 5px"}}>Send Email</label>
  </div> */}
  <button onClick={handleEmailButton} className={`add-cc-btn ${sendEmail ? 'remove' : ''}`} type="button"> 
    <FeatherIcon icon="mail" className={sendEmail ? 'icon-active' : ''}  />
    <span style={{marginLeft:"5px"}}>{sendEmail ? 'Remove CC emails' : 'Add more CC emails'}</span>
  </button>

  {sendEmail && (
    <>
    <Chips
      value={emails}
      onChange={handleEmailChange}
      separator=","
      placeholder="Add cc emails..."
      className=""
    />
    <small className="p-d-block" style={{color:"#6c757d",margin:"0px"}}>Press enter or comma to add emails</small>
    </>
  )}
</div>
: null}
      </div>
    </div>
  )
}

export default ChatPage